import { getTypeCardBasePath } from '@/react-query/common';

import { CardActivation, CardType } from '@generated-types';
import { cardTypePatch } from '@utils/query-utils';

export const activateCard = async (cardType: CardType, cardId: string) =>
    cardTypePatch(cardType)(`${getTypeCardBasePath(cardType)}/${cardId}/activation`, CardActivation.ACTIVE);
